import FloatingLogo from './FloatingLogo';
export default FloatingLogo;
